import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SubHeader from "./SubHeader";
import { BASE_URL } from "../Apis/apiConfig";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const PerviousYearLedger = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [loading, setLoading] = useState(true);
    const [selectedMember, setSelectedMember] = useState(null);
    const [ledgerData, setLedgerData] = useState([]);
    const [societyData, setSocietyData] = useState(null);
    const [filterFromDate, setFilterFromDate] = useState("");
    const [filterToDate, setFilterToDate] = useState("");
    const [showLedger, setShowLedger] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const unitNo = location.state?.unitNo;
    const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
    const ledgerRef = useRef();


    const downloadPDF = () => {
        const input = ledgerRef.current;
        if (!input) return;
        const button = input.querySelector(".download-btn");
        if (button) button.style.display = "none";

        html2canvas(input, { scale: 2 }).then((canvas) => {
            const imgData = canvas.toDataURL("image/png");
            const pdf = new jsPDF("p", "mm", "a4");
            const imgProps = pdf.getImageProperties(imgData);
            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

            pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
            pdf.save(`Ledger_${unitNo}.pdf`);
            if (button) button.style.display = "block";
        });
    };

    useEffect(() => {
        if (!unitNo) {
            setLoading(false);
            return;
        }
        const fetchMember = async () => {
            try {
                const token = localStorage.getItem("token");
                const society = localStorage.getItem("society");

                const response = await axios.get(`${BASE_URL}/api/member/get-list`, {
                    params: { society },
                    headers: { Authorization: `Bearer ${token}` },
                });

                const member = response.data.find((m) => m.unit_no === unitNo);
                setSelectedMember(member);
            } catch (error) {
                console.error("Fetch Member Error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchMember();
    }, [unitNo]);

    useEffect(() => {
        const fetchSocietyDetails = async () => {
            try {
                const token = (localStorage.getItem("token") || "").trim();
                const societyName = (localStorage.getItem("society") || "").trim();
                const registered = (localStorage.getItem("societyRegNo") || "").trim();

                const response = await axios.post(
                    `${BASE_URL}/api/get-society-by-admin`,
                    null,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                        params: { societyName, societyRegistrationNo: registered },
                        validateStatus: (s) => s < 500,
                    }
                );

                if (response.status === 200) setSocietyData(response.data);
            } catch (error) {
                if (error.name !== "CanceledError") console.error(error);
            }
        };

        fetchSocietyDetails();
    }, []);

  const getFinancialYear = () => {
    if (!filterFromDate || !filterToDate) return "";

    const from = new Date(filterFromDate);
    const to = new Date(filterToDate);

    const startYear = from.getFullYear();
    const endYear = to.getFullYear();

    return `${startYear}-${endYear}`;
};

   const fetchLedgerCurrentYear = async () => {
    try {
        const token = (localStorage.getItem("token") || "").trim();
        const societyName = (localStorage.getItem("society") || "").trim();

        const response = await axios.post(
            `${BASE_URL}/ledger/get-ledger-financial-pervious`,
            null,
            {
                params: {
                    wingFlat: selectedMember.unit_no,
                    societyName,
                    fromDate: filterFromDate,
                    toDate: filterToDate
                },
                headers: { Authorization: `Bearer ${token}` },
            }
        );

        setLedgerData(response.data);
    } catch (error) {
        console.error("Ledger API Error:", error);
    }
};

    const capitalizeWords = (str) => {
        return str
            .toLowerCase()
            .split(" ")
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    const handleSearch = () => {
    if (!filterFromDate || !filterToDate) {
        alert("Please select From and To Date");
        return;
    }

    fetchLedgerCurrentYear(); 
    setShowLedger(true);
};


    return (
        <div className="app-container">
            <Header toggleSidebar={toggleSidebar} />
            <div className="main-layout">
                <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />
                <main className="content-area">
                    <SubHeader />
                    {loading ? (
                        <h3>Loading...</h3>
                    ) : selectedMember ? (
                        <>
                    
                            <div style={{ margin: "20px 0", padding: "15px", border: "1px solid #ddd", borderRadius: "6px",
                                background: "#f9f9f9", display: "flex",
                                gap: "15px",
                                alignItems: "center",
                                flexWrap: "wrap"
                            }}>
                                <div>
                                    <label>From Date</label><br />
                                    <input
                                        type="date"
                                        value={filterFromDate}
                                        onChange={(e) => setFilterFromDate(e.target.value)}
                                        style={{ padding: "6px" }}
                                    />
                                </div>

                                <div>
                                    <label>To Date</label><br />
                                    <input
                                        type="date"
                                        value={filterToDate}
                                        onChange={(e) => setFilterToDate(e.target.value)}
                                        style={{ padding: "6px" }}
                                    />
                                </div>
                                <div style={{ marginTop: "20px" }}>
                                    <button
                                        onClick={handleSearch}
                                        style={{
                                            padding: "8px 15px",
                                            backgroundColor: "#007bff",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: "pointer"
                                        }}
                                    >
                                        Search
                                    </button>
                                </div>
                            </div>
                            {showLedger && (
                                <div ref={ledgerRef} className="ledger-container">
                                    <div className="ledger-header">
                                        <h2>{capitalizeWords(localStorage.getItem("society"))}</h2>
                                        <p>
                                            Registration No.: {societyData?.societyRegistrationNo}{" "}
                                            {selectedMember?.address},{" "}
                                            {selectedMember?.pincode}{" "}
                                            Phone: {selectedMember?.phone_number}
                                            {selectedMember?.phone_number_2 && `, ${selectedMember.phone_number_2}`}
                                            {selectedMember?.phone_number_3 && `, ${selectedMember.phone_number_3}`}
                                        </p>
                                        <p> For The Year {getFinancialYear()}  {filterFromDate && ` From ${filterFromDate}`} 
                                             {filterToDate && ` To ${filterToDate}`} </p>
                                    </div>

                                    <div className="unit-info">
                                        Unit No: <strong>{selectedMember.unit_no}</strong> | {selectedMember.member_name}
                                    </div>

                                    <button
                                        className="download-btn"
                                        onClick={downloadPDF}
                                        style={{
                                            margin: "15px 0",
                                            padding: "8px 12px",
                                            backgroundColor: "#007bff",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "4px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Download PDF
                                    </button>

                                    <table className="ledger-table">
                                        <thead>
                                            <tr>
                                                <th>Date</th>
                                                <th>Reference Type</th>
                                                <th>No.</th>
                                                <th>Cheque No.</th>
                                                <th>Cheque Date</th>
                                                <th>Dr Amount</th>
                                                <th>Cr Amount</th>
                                                <th>Balance</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ledgerData.length > 0 ? (
                                                ledgerData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.previousYearLedgerDate}</td>
                                                        <td>{item.vchType}</td>
                                                        <td>{item.ledgerId}</td>
                                                        <td>{item.chequeNo || "-"}</td>
                                                        <td>{item.chequeDate || "-"}</td>
                                                        <td>{item.debit || "0.00"}</td>
                                                        <td>{item.credit || "0.00"}</td>
                                                        <td>{item.balance}</td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8">No Ledger Data Found</td>
                                                </tr>
                                            )}
                                        </tbody>

                                        {ledgerData.length > 0 && (
                                            <tfoot>
                                                <tr>
                                                    <td colSpan="5"><strong>Total</strong></td>
                                                    <td>
                                                        <strong>
                                                            {ledgerData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0).toFixed(2)}
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        <strong>
                                                            {ledgerData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0).toFixed(2)}
                                                        </strong>
                                                    </td>
                                                    <td>
                                                        {/* <strong>
                                                            {(
                                                                ledgerData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0) -
                                                                ledgerData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0)
                                                            ).toFixed(2)} Dr
                                                        </strong> */}
                                                         
                                                        <td>{ledgerData[ledgerData.length - 1].balance}</td>
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        )}
                                    </table>
                                </div>
                            )}
                        </>
                    ) : (
                        <h3>No Member Found</h3>
                    )}
                </main>
            </div>
        </div>
    );
};

export default PerviousYearLedger;
